module.exports = __webpack_public_path__ + "static/img/Virgo.e1cd4f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/horoscope_icon/Virgo.svg
// module id = 377
// module chunks = 0